import { render } from "./InvoiceMandateSetupModal.vue?vue&type=template&id=cdaa4c54"
import script from "./InvoiceMandateSetupModal.vue?vue&type=script&lang=js"
export * from "./InvoiceMandateSetupModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__